/* ============
 * Vue Router
 * ============
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes';
import UserInfoTool from '@/tools/UserInfoTool';
import UrlTool from '@/tools/UrlTool';

Vue.use(VueRouter);

export const router = new VueRouter({
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
  mode: 'history',
});

const signInIsDisabled = process.env.VUE_APP_SIGN_IN_DISABLED === 'true';
const hasMultipleSignIn = process.env.VUE_APP_MULTIPLE_SIGN_IN === 'true';

if (signInIsDisabled) {
  router.beforeEach((to, from, next) => {
    if (to.path !== '/register') {
      next({ name: 'auth.register' });
    } else {
      next();
    }
  });
} else {
  router.beforeEach((to, from, next) => {
    // eslint-disable-next-line prefer-destructuring
    const authPath = UrlTool.isAuthPath();
    const userInfo = UserInfoTool.getUserInfo();
    const isSignedIn = userInfo.signedIn;

    if (hasMultipleSignIn && to.path === '/sign-in' && from.path !== '/multi-sign-in') {
      next({
        name: 'auth.multiple.sign.in',
        params: {
          redirectTo: to,
        },
        query: to.query,
      });
    }
    if (hasMultipleSignIn && to.path === '/register' && from.path !== '/multi-sign-in') {
      next({
        name: 'auth.multiple.sign.in',
        params: {
          redirectTo: to,
        },
        query: to.query,
      });
    }
    if (authPath) {
      if (!to.matched.length || (to.matched.some((m) => m.meta.auth) && !isSignedIn)) {
        // User is not signed in and tries to visit a page that requires signing in
        // OR the page doesn't exist
        next({
          name: 'auth.sign.in',
          params: {
            redirectTo: to,
          },
        });
        // eslint-disable-next-line brace-style
      } else if ((to.matched.some((m) => m.meta.guest) && isSignedIn)
        || (!to.matched.some((m) => m.name))
        || to.matched.some((m) => m.meta.app === 'emails')) {
        // User tries to go to a page that doesn't exist
        // or a signed in user tries to go to a guest page
        next({
          name: 'general.not.found',
          params: {
            redirectTo: to,
          },
        });
      } else {
        next();
      }
    }
    // else if (subdomain === 'emails') {
    //   // TODO this block can be removed after admin UI is entirely separated from auth
    //   if (!isAdmin) {
    //     // Admin UI is only available for admins, other are directed to not found
    //     next({
    //       name: 'general.not.found',
    //       params: {
    //         redirectTo: to,
    //       },
    //     });
    //   } else if (to.path !== '/mail-sends') {
    //     // Always show mail sends to admins
    //     next({
    //       name: 'admin.send.magic.links',
    //       params: {
    //         redirectTo: to,
    //       },
    //     });
    //   } else {
    //     next();
    //   }
    // }
  });
}

Vue.router = router;

export default {
  router,
};
